import { render, staticRenderFns } from "./SectionProductFrom2025.vue?vue&type=template&id=bac1dd38"
import script from "./SectionProductFrom2025.vue?vue&type=script&lang=ts"
export * from "./SectionProductFrom2025.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports